import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import GuidePage from "@/pages/guide/page";
import ShoesGuide from "@/pages/guide/shoes/page";
import ClothingGuide from "@/pages/guide/clothing/page";
import SafetyGuide from "@/pages/guide/safety/page";
import BeginnerGuide from "@/pages/guide/beginner/page";
import BenefitsGuide from "@/pages/guide/benefits/page";
import AlternativesGuide from "@/pages/guide/alternatives/page";
import HowToUseGuide from "@/pages/guide/how-to-use/page";
import ShippingGuide from "@/pages/guide/shipping/page";
import FAQPage from "@/pages/guide/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guide",
    element: <GuidePage />,
  },
  {
    path: "/guide/shoes",
    element: <ShoesGuide />,
  },
  {
    path: "/guide/clothing",
    element: <ClothingGuide />,
  },
  {
    path: "/guide/safety",
    element: <SafetyGuide />,
  },
  {
    path: "/guide/beginner",
    element: <BeginnerGuide />,
  },
  {
    path: "/guide/benefits",
    element: <BenefitsGuide />,
  },
  {
    path: "/guide/alternatives",
    element: <AlternativesGuide />,
  },
  {
    path: "/guide/how-to-use",
    element: <HowToUseGuide />,
  },
  {
    path: "/guide/shipping",
    element: <ShippingGuide />,
  },
  {
    path: "/guide/faq",
    element: <FAQPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;